module.exports = __webpack_public_path__ + "static/media/otro.2be067d4.png";